var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[[_c('list-group',{attrs:{"title":'充電／お手入れ'}},[_c('list-item',{attrs:{"spanText":'Q. ',"text":'充電マークが出ない/バッテリー残量が増えない',"urlName":'Help26'}}),_vm._v(" "),_c('list-item',{attrs:{"spanText":'Q. ',"text":'バッテリーの持ち時間について',"urlName":'Help18'}})],1)]],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3e5fa8a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HelpCategory34.vue
// module id = mJKO
// module chunks = 0